/**
 * Formats a phone number string by inserting spaces.
 * Strips non-digit characters, limits to 10 digits.
 * Groups flexibly based on total length:
 *   - 10 digits: XXX XXX XXXX  (e.g. 351 111 3333)
 *   - 8 digits:  XXXX XXXX     (e.g. 1234 5678)
 *   - Other:     groups of 3-4 as needed
 */
export function formatPhone(value) {
  const digits = value.replace(/\D/g, '').slice(0, 10);
  const len = digits.length;

  if (len <= 3) return digits;
  if (len <= 6) return `${digits.slice(0, 3)} ${digits.slice(3)}`;
  if (len <= 8) return `${digits.slice(0, 4)} ${digits.slice(4)}`;
  return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
}

/**
 * onChange handler helper: formats the input value and calls the setter.
 */
export function handlePhoneChange(e, setter) {
  setter(formatPhone(e.target.value));
}
